import { sendServerEvent } from './freshpaint';

export enum ServerSideAnalyticsEvent {
  PROVIDER_MATCH = 'Matched Patient With Providers',
  PROVIDER_SCHEDULE = 'Fetched Provider Availability',
  ZOCDOC_PROVIDER_MATCH = 'Matched Patient With ZocDoc Provider',
  BOOKED_APPOINTMENT = 'step1A',
  COMPLETED_FIRST_APPOINTMENT = 'step2B',
  COMPLETED_SECOND_APPOINTMENT = 'step3C',
}

export enum FreshpaintUserIdType {
  FRESHPAINT_USER_ID = 'freshpaintId',
  SESSION_PATIENT_ID = 'sessionPatientId',
}

export type AnalyticsUserInfo = {
  id: string;
  idType: FreshpaintUserIdType;
};

export const sendServerAnalyticsEvent = (
  eventName: ServerSideAnalyticsEvent,
  user: AnalyticsUserInfo,
  properties?: Object
): void => {
  void sendServerEvent(eventName, user, properties);
};
